<template>
  <teleport to="body">
    <div class="modal-overlay" @click.self="emit('close')">
      <div class="modal-content">
        <h2>{{ $t('login.title') }}</h2>
        <form @submit.prevent="login">
          <input v-model="email" type="email" :placeholder="$t('login.email')" required />
          <input v-model="password" type="password" :placeholder="$t('login.password')" required />
          <p v-if="errorMessage" class="error">{{ errorMessage }}</p>
          <button class="btn-primary" type="submit">{{ $t('login.button') }}</button>
        </form>
          <p class="register-link">
            {{ $t('login.noAccount') }}
            <span @click="goToRegister">{{ $t('login.register') }}</span>
          </p>
        <button class="btn-close" @click="emit('close')">&times;</button>
      </div>
    </div>
  </teleport>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/store/user'
import { defineEmits } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const email = ref('')
const password = ref('')
const errorMessage = ref('')
const emit = defineEmits(['success', 'close'])
const baseUrl = process.env.VUE_APP_API_URL
const userStore = useUserStore()
const router = useRouter()

function goToRegister() {
  emit('close')  // popup'ı kapat
  router.push('/register')  // kayıt sayfasına yönlendir
}
async function login() {
  errorMessage.value = ''
  try {
    const res = await fetch(`${baseUrl}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email.value, password: password.value }),
    })

    const data = await res.json()

    if (!res.ok) {
      errorMessage.value = data.message || t('login.error')
      return
    }

    userStore.setAuth(data.token, data.user)

    switch (data.user.role) {
      case 'translator':
        router.push('/panel/translator')
        break
      case 'admin':
        router.push('/panel/admin')
        break
      default:
        router.push('/panel/user')
    }

    emit('success')
    emit('close')
  } catch (err) {
    errorMessage.value = t('login.serverError')
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.register-link {
  text-align: center;
  font-size: 14px;
  margin-top: 10px;
  color: #333;
}

.register-link span {
  color: #0c2d57;
  font-weight: bold;
  cursor: pointer;
  text-decoration: underline;
}

.register-link span:hover {
  color: #0a2444;
}


.modal-content {
  background-color: white;
  padding: 30px;
  border-radius: 12px;
  width: 90%;
  max-width: 400px;
  position: relative;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

.modal-content h2 {
  margin-bottom: 20px;
  font-size: 22px;
  text-align: center;
  color: black;
}

.modal-content input {
  width: 100%;
  padding: 12px;
  margin-bottom: 14px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 14px;
}

.btn-primary {
  background-color: #0c2d57;
  color: white;
  padding: 10px;
  border: none;
  border-radius: 8px;
  font-weight: bold;
  cursor: pointer;
  width: 100%;
}

.btn-primary:hover {
  background-color: #0a2444;
}

.btn-close {
  position: absolute;
  top: 10px;
  right: 14px;
  background: none;
  border: none;
  font-size: 24px;
  color: #999;
  cursor: pointer;
}

.error {
  color: red;
  font-size: 13px;
  margin-bottom: 10px;
}
@media (max-width: 480px) {
  .modal-content {
    padding: 20px;
    width: 90%;
    max-width: 95%;
  }

  .modal-content h2 {
    font-size: 20px;
    margin-bottom: 16px;
  }

  .modal-content input {
    padding: 10px;
    font-size: 13px;
    border-radius: 6px;
  }

  .btn-primary {
    padding: 10px;
    font-size: 15px;
    border-radius: 6px;
  }

  .btn-close {
    font-size: 20px;
    top: 6px;
    right: 10px;
  }

  .error {
    font-size: 12px;
  }
}

</style>
